<template>
  <div>
    <youtubePop :visible="isYoutube" :youtube="youtube" @close="layerClose"></youtubePop>
    <div class="wrap home-wrap">
      <div class="home-header">
        <h1>
          <img src="@/assets/img/logo_beta.png" alt="로고" class="w-150px" />
        </h1>
        <h3>
          <img src="@/assets/img/chat.svg" alt="메시지" @click="showMessage()" />
          <span>{{ unreadCount }}</span>
        </h3>
      </div>
      <div class="body-wrap">
        <div class="my-coaching">
          <div class="coaching-count">
            <img src="@/assets/img/coaching-count.svg" alt="남은 코칭아이콘" />
            <p>
              남은 코칭 <span>{{ sessionCount }}</span>
            </p>
          </div>
          <div class="welecome-txt">
            <p>안녕하세요, {{ nexCoarchingDay.userName }}님!</p>
            현재 <span class="bold">{{ nexCoarchingDay.coarchName }} 코치</span>님과 함께 하고 있습니다.
          </div>
          <div class="next-coaching" v-if="nexCoarchingDay.list != null">
            <p class="bold">
              <img src="@/assets/img/next-coaching.svg" alt="시계" />
              다음 코칭예정일
              <span></span>
              {{ $date(nexCoarchingDay.list.startDatetime).format("YYYY-MM-DD") }} {{ nexCoarchingDay.list.day }}요일
            </p>
          </div>
        </div>
        <div class="my-coaching-btn">
          <ul>
            <li @click="coachingRecom()">
              <img src="@/assets/img/calendar.svg" alt="달력" />
              <p>코칭 예약하러 가기</p>
            </li>
            <li @click="complateCoaching()">
              <img src="@/assets/img/writing.svg" alt="쓰기" />
              <p>이전 성찰노트 보기</p>
            </li>
          </ul>
        </div>
        <div class="coach-recommend-wrap" v-if="isYouTubeLoading">
          <h3>
            코치님이 추천한 영상
            <span @click="moreVideo()">more</span>
          </h3>
          <div class="coach-recommend" @click="popShow()">
            <h4 class="title">{{ youtube.contentTitle }}</h4>
            <div class="youtube-wrap">
              <!-- <img src="@/assets/img/youtube.png" alt="영상썸네일"> -->
              <img :src="yottubeThum" alt="영상썸네일" style="width: 100%" />
            </div>
            <p>
              {{ youtube.contentReasonsRecommendation }}
            </p>
          </div>
        </div>
      </div>

      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incTab from "@/components/inc/inc_tab.vue";
import dayjs from "dayjs";
import youtubePop from "@/components/pop/youtube_pop.vue";
export default {
  name: "home",
  data: () => ({
    isLayer: false,
    messageCount: 0,
    sessionCount: 0,
    userName: "학습자이름",
    coarching: {
      userName: "우리집",
      nextDate: "2021-12-22(수)",
      nextDay: "",
    },
    weekday: ["일", "월", "화", "수", "목", "금", "토"],
    youtube: {},
    isYouTubeLoading: false,
    yottubeThum: "",
    isYoutube: false,
    unreadCount: 0,
    totalReceivedCount: 0,
    nexCoarchingDay: {},
    currentCoarching: 0,
  }),
  components: {
    incTab,
    youtubePop,
  },
  mounted() {
    this.getCoarchingIdx();

    this.getUserName();

    this.getYoutube();

    this.getMessageCount();
  },
  methods: {
    getCoarchingIdx() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
        courseIdx: this.$store.state.userInfo.courseIdx,
      };
      this.axios
        .get("/front/find/coarchingidx", { params })
        .then((res) => {
          if (res.data.success) {
            let tempCoarching = res.data.data;
            this.currentCoarching = tempCoarching[0].coarchingIdx;
            this.$store.commit("setCurrentCoaching", this.currentCoarching);
            console.log("/front/find/coarchingidx", "호출 이후 getSessionCount() 실행");
            this.getSessionCount();
            console.log("/front/find/coarchingidx", "호출 이후 getNextCoarching() 실행");
            this.getNextCoarching();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMessageCount() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/chat/count", { params })
        .then((res) => {
          if (res.data.success) {
            let tempCount = res.data.contentinfo;
            this.unreadCount = tempCount.qnaUnreadCount + tempCount.unreadCount;
            if (this.unreadCount >= 100) {
              this.unreadCount = "99+";
            }
            this.totalReceivedCount = res.data.contentinfo.totalReceivedCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getNextCoarching() {
      let params = {
        courseIdx: this.currentCoarching,
      };
      this.axios
        .get("/front/home/nextcoarchingday", { params })
        .then((res) => {
          if (res.data.success) {
            this.nexCoarchingDay = res.data.contentinfo.nexCoarchingDay;
            if (this.nexCoarchingDay.list != null) {
              this.$store.commit("setCoachingDays", dayjs(this.nexCoarchingDay.list.startDatetime).day());
              this.nexCoarchingDay.list.day = this.$store.state.coachingDays;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getYoutube() {
      this.axios
        .get(`/content/recommend/coach/${this.$store.state.userInfo.userIdx}?page=1`)
        .then((res) => {
          if (res.data.success) {
            let youtubeTemp = res.data.data;
            if (!youtubeTemp.length) {
              console.log(
                "/content/recommend/coach/${this.$store.state.userInfo.userIdx}?page=1 API 동작 이후 getHqYoutube() 실행"
              );
              this.getHqYoutube();
            } else {
              this.youtube = res.data.data[0];
              // isYouTube
              if (typeof this.youtube !== "undefined") {
                this.getThum();
                this.isYouTubeLoading = true;
              } else {
                this.isYouTubeLoading = false;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getHqYoutube() {
      this.axios
        .get("/content/recommend/hq?page=1")
        .then((res) => {
          if (res.data.success) {
            this.youtube = res.data.data[0];
            if (typeof this.youtube !== "undefined") {
              console.log("/content/recommend/hq?page=1 동작 이후 getThum() 함수 실행");
              this.getThum();
              this.isYouTubeLoading = true;
            } else {
              this.isYouTubeLoading = false;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getThum() {
      let replaceUrl = this.youtube.contentVideoUrl;
      let finUrl = "";
      replaceUrl = replaceUrl.replace("https://m.youtube.com/watch?v=", "");
      replaceUrl = replaceUrl.replace("https://youtu.be/", "");
      replaceUrl = replaceUrl.replace("https://www.youtube.com/embed/", "");
      replaceUrl = replaceUrl.replace("https://www.youtube.com/watch?v=", "");
      finUrl = replaceUrl.split("&")[0];
      this.yottubeThum = "https://img.youtube.com/vi/" + finUrl + "/hqdefault.jpg";
    },
    getCoarching() {
      let params = {
        courseIdx: this.$store.state.courseInfo.courseIdx,
      };
      this.axios
        .get("/front/home/coarchname", { params })
        .then((res) => {
          if (res.data.success) {
            this.coarching = res.data.contentinfo;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getUserName() {
      let params = {
        userIdx: 0,
      };
      params.userIdx = this.$store.state.userInfo.userIdx;

      this.axios
        .get("/front/home/username", { params })
        .then((res) => {
          if (res.data.success) {
            this.userName = res.data.contentinfo;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSessionCount() {
      let params = {
        coarchingIdx: this.currentCoarching,
      };
      this.axios
        .get("/front/home/leftcoarching", { params })
        .then((res) => {
          if (res.data.success) {
            this.sessionCount = res.data.contentinfo;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    moreVideo() {
      this.$router.push("coach_recommend_video");
    },
    layerClose() {
      this.isYoutube = false;
    },
    popShow() {
      this.isYoutube = true;
    },
    showMessage() {
      this.$router.push("coaching_message");
    },
    coachingRecom() {
      this.$router.push({ name: "coach_recom", params: { rebook: 1 } });
    },
    complateCoaching() {
      this.$router.push("complate_coaching");
    },
  },
};
</script>
